import { indexToRC } from './indexToRC'
import { rcToIndex } from './rcToIndex'

/**
 * Gets indices of tiles adjacent to the empty cell
 *
 * Returns all valid neighboring positions (up, down, left, right)
 * of the empty cell. These are the tiles that can legally move.
 *
 * @param {number} emptyIndex - Current index of the empty cell
 * @param {number} size - Board dimension (e.g., 3 for 3x3)
 * @returns {number[]} Array of indices that can move into empty space
 *
 * @example
 * // For a 3x3 board with empty at center (index 4):
 * // [0][1][2]
 * // [3][X][5]
 * // [6][7][8]
 * neighborsOfEmpty(4, 3)  // [1, 7, 3, 5] (up, down, left, right)
 *
 * // Empty at corner (index 0):
 * // [X][1][2]
 * // [3][4][5]
 * // [6][7][8]
 * neighborsOfEmpty(0, 3)  // [3, 1] (down, right only)
 *
 * // Empty at edge (index 1):
 * // [0][X][2]
 * // [3][4][5]
 * // [6][7][8]
 * neighborsOfEmpty(1, 3)  // [4, 0, 2] (down, left, right)
 */
export function neighborsOfEmpty (emptyIndex, size) {
  const [r, c] = indexToRC(emptyIndex, size)
  const res = []
  if (r > 0) res.push(rcToIndex(r - 1, c, size)) // up
  if (r < size - 1) res.push(rcToIndex(r + 1, c, size)) // down
  if (c > 0) res.push(rcToIndex(r, c - 1, size)) // left
  if (c < size - 1) res.push(rcToIndex(r, c + 1, size)) // right
  return res
}
